import { Dropdown, Pagination, Space, Tooltip } from "antd";
import { AiTwotoneSetting } from "react-icons/ai";
import {
  FaEdit,
  FaEllipsisV,
  FaEye,
  FaEyeSlash,
  FaInfoCircle,
  FaTrashRestoreAlt,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Alert from "../../../../global/alert/Alert";
import {
  useDelete,
  useStatusChange,
} from "../../../../../utils/CustomFunctions";
import { IoCloseSharp } from "react-icons/io5";
import { MdDelete } from "react-icons/md";
import { useState } from "react";

export const Table = ({ blogs }) => {
  const server = process.env.REACT_APP_SERVER;
  // this is alert maessage
  const msg = {
    icon: <FaInfoCircle className="me-3" />,
    type: "alert-info",
    text: "No blogs found",
  };

  // for state change
  const { loading, handleStatusChange } = useStatusChange(
    "admin",
    "blog_change_status",
    "blogs",
    "blogs"
  );

  // for soft delete and parmanently delete
  const { isLoading, handleDelete } = useDelete(
    "admin",
    "blogs",
    "blogs",
    "blog_categories"
  );

  // for pagination purposes
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const indexOfLastData = currentPage * itemsPerPage;
  const indexOfFirstData = indexOfLastData - itemsPerPage;
  const currentData = blogs?.slice(indexOfFirstData, indexOfLastData);

  return (
    <>
      <div className="row organizer-event">
        <div className="col-12">
          {blogs && blogs.length > 0 ? (
            <div className="card">
              <div className="table-responsive">
                <table className="table table-hover table-vcenter">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Category</th>
                      <th>Image</th>
                      <th>Status</th>
                      <th className="text-center">
                        <AiTwotoneSetting />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData?.map((blog) => {
                      const items = [
                        {
                          label: (
                            <Link
                              to={`${blog.slug}/edit`}
                              className="d-flex align-items-center"
                            >
                              <FaEdit className="me-1" />
                              Edit
                            </Link>
                          ),
                          key: "0",
                        },
                        {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) => handleStatusChange(e, blog.id)}
                            >
                              {blog.status === "visible" ? (
                                <>
                                  <FaEyeSlash className="me-1" />
                                  Hidden
                                </>
                              ) : (
                                <>
                                  <FaEye className="me-1" /> Show
                                </>
                              )}
                            </Link>
                          ),
                          key: "1",
                        },
                        {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) =>
                                handleDelete(e, blog.id, "blog_delete", "")
                              }
                            >
                              {blog.deleted_at !== null ? (
                                <>
                                  <FaTrashRestoreAlt className="me-1" /> Restore
                                </>
                              ) : (
                                <>
                                  <IoCloseSharp className="me-1" />
                                  Delete
                                </>
                              )}
                            </Link>
                          ),
                          key: "3",
                        },
                        blog.deleted_at && {
                          label: (
                            <Link
                              to=""
                              className="d-flex align-items-center"
                              onClick={(e) =>
                                handleDelete(
                                  e,
                                  blog.id,
                                  "blog_delete_permanent",
                                  "delete_permanent"
                                )
                              }
                            >
                              <MdDelete className="me-1" />
                              Delete permanently
                            </Link>
                          ),
                          key: "4",
                        },
                      ];
                      return (
                        <tr key={blog.id}>
                          <td>
                            <Link to={`/en/blog-article/${blog?.slug}`}>
                              {blog?.name}
                            </Link>
                          </td>
                          <td className="text-capitalize">
                            {blog?.category?.name}
                          </td>
                          <td>
                            <Tooltip title="Enlarge">
                              {blog?.image ? (
                                <Link
                                  className="fancybox"
                                  to={`${server}/blog/${blog?.image}`}
                                  target="_blank"
                                >
                                  <img
                                    src={`${server}/blog/${blog?.image}`}
                                    className="img-thumbnail img-50-50"
                                  />
                                </Link>
                              ) : (
                                <img
                                  src="/./images/noPhoto.png"
                                  className="img-thumbnail img-50-50"
                                  alt=""
                                />
                              )}
                            </Tooltip>
                          </td>
                          <td className="">
                            <span
                              className={`badge badge-${
                                blog?.status === "visible"
                                  ? "success"
                                  : "danger"
                              } d-inline-flex align-items-center`}
                            >
                              {blog?.status === "visible" ? (
                                <>
                                  <FaEye className="me-1" /> Visible
                                </>
                              ) : (
                                <>
                                  <FaEyeSlash className="me-1" />
                                  Hidden
                                </>
                              )}
                            </span>

                            {blog?.deleted_at && (
                              <>
                                <br />
                                <br />
                                <span className="badge badge-danger d-inline-flex align-items-center">
                                  <IoCloseSharp className="me-1" />
                                  Deleted
                                </span>
                              </>
                            )}
                          </td>
                          <td className="text-center">
                            <Dropdown
                              menu={{
                                items,
                              }}
                              trigger={["click"]}
                            >
                              <a onClick={(e) => e.preventDefault()}>
                                <Space className="justify-content-center">
                                  <FaEllipsisV />
                                </Space>
                              </a>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <Alert {...msg} />
          )}
        </div>
      </div>

      {blogs?.length > 10 && (
        <Pagination
          current={currentPage}
          total={blogs.length}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
        />
      )}
    </>
  );
};
